<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title
        h1.subheading Ticket Rating
    div#rating-line
</template>

<script>
export default {
  props: ['rating'],
  watch: {
    rating(val) {
      var HighChartPie = $('#rating-line');
      if (HighChartPie.length) {

        HighChartPie.highcharts({
          credits: false, // Disable HighCharts logo
          colors: ['green', '#4a89dc', '#3bafda', '#8A1B1D'], // Set Colors
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
              text: null
          },
          tooltip: {
              pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                  enabled: false
              },
              showInLegend: true
            }
          },
          series: [{
            type: 'pie',
            colorByPoint: true,
            name: 'Status',
            data: val
          }]
        });
      }
    }
  },
}
</script>
